export function transformPath(path, from, to) {
  try {
    return path.replace(new RegExp(`${from}`), to);
  } catch (e) {
    return path;
  }
}